module.exports = __webpack_public_path__ + "static/media/brunopellicci.d20a2452.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/brunopellicci.webp
// module id = 299
// module chunks = 0